import { Button } from 'react-bootstrap';
import React, { useCallback } from 'react';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { pwaSlice } from '../pwaReducer';
import { useDispatch } from 'react-redux';

interface IPwaInstallButtonProps {
    className?: string,
    onDownloadButtonClick?: () => void,
    size?: 'sm' | 'lg',
}

function PwaInstallButton(props: IPwaInstallButtonProps) {
    const { className, onDownloadButtonClick, size } = props;
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();

    const handleButtonClick = useCallback(() => {
        onDownloadButtonClick && onDownloadButtonClick();
        dispatch(pwaSlice.actions.openPwaInstallPromptAction());
    }, [dispatch, onDownloadButtonClick]);

    return <Button variant="primary" onClick={handleButtonClick} className={className} size={size}>
        {getLangPath('pwa.install')}
    </Button>
}

export default PwaInstallButton;
